import React, { useState } from 'react';
import { FileColumn } from '../StartCalendar/utils/ColumnsFormatters/FileColumn';
import { ModalRechazoArchivo } from '../StartCalendar/Component/ModalRechazoArchivo';
import { filesAPI } from 'src/api/modules/files';
import notice from 'src/common/components/Notice';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const TablaDocumentos = ({
	inpustfile = 0,
	items = [],
	columns = [],
	onClickEnviar,
	disabled = false,
	setFlagRender = null,
}) => {
	const [openModal, setOpenModal] = useState(false);
	const [dataModal, setDataModal] = useState({});
	const { user } = useSelector((state) => state.auth);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const [itemsReTe, setItemsReTe] = useState(items);
	//const [sendDisabled, setsendDisabled] = useState(disabled);
	const [inpustfileC, setinpustfileC] = useState(inpustfile);

	const _onArchivoClick = (data) => {
		setDataModal(data);
		setOpenModal(true);
	};
	const _onClickEnviar = () => {
		if (onClickEnviar)
			onClickEnviar(systemLevelRole, user.nombre + ' ' + user.apellidoPaterno);
	};
	// const checkIsDisabledSend = (archivos) => {
	// 	const oficio = archivos.find((x) => x.tipo === 'O');
	// 	const tarjeta = archivos.find((x) => x.tipo === 'T');
	// 	const presentacion = archivos.find((x) => x.tipo === 'P');
	// 	//const adicional = archivos.find((x) => x.tipo === 'A');
	// 	let isSendDisabled = true;

	// 	if (oficio != null && tarjeta != null && presentacion != null) {
	// 		if (
	// 			(oficio.validaSeguimiento == 'APO' &&
	// 				tarjeta.validaSeguimiento == 'APO' &&
	// 				presentacion.validaSeguimiento == 'APO') ||
	// 			(oficio.validaSeguimiento == 'A' &&
	// 				tarjeta.validaSeguimiento == 'A' &&
	// 				presentacion.validaSeguimiento == 'A')
	// 		)
	// 			isSendDisabled = false;
	// 	}
	// 	return isSendDisabled;
	// };
	const _onArchivoAceptar = (currentdataMinos, index, currenticon) => {
		let estatus = systemLevelRole === 'RESPONSABLE DE SEGUIMIENTO' ? 'APO' : 'A';
		filesAPI
			.changeEstatus(currentdataMinos.id, estatus)
			.then((response) => {
				itemsReTe[index].dataMinos[currenticon].estatus = estatus;

				const copyData = [...itemsReTe];
				//const isDisabledSend = checkIsDisabledSend(itemsReTe[index].dataMinos);
				setItemsReTe([]);
				setItemsReTe(copyData);
				setinpustfileC([]);
				setinpustfileC(inpustfile);
				//setsendDisabled(isDisabledSend);
				notice('Archivo aceptado correctamente', 'success');
				if (setFlagRender !== null) setFlagRender(true);
			})
			.catch((err) => notice('Ocurrio un error al aceptar el archivo', 'error'));
	};
	const onGetStatus = (data) => {
		switch (systemLevelRole.toUpperCase()) {
			case 'ENLACE':
				if (
					data.dataMinos.some(
						(item) => item.estatus === 'R' || item.estatus === 'RR'
					)
				) {
					return true;
				} else {
					return data.enviadoEnlace;
				}
			case 'RESPONSABLE DE SEGUIMIENTO':
				if (
					data.dataMinos.some(
						(item) => item.estatus === 'R' || item.estatus === 'RR'
					)
				) {
					return true;
				} else {
					return data.enviadoRS;
				}
			case 'RESPONSABLE DE ORGANO COLEGIADO':
				if (
					data.dataMinos.some(
						(item) => item.estatus === 'R' || item.estatus === 'RR'
					)
				) {
					return true;
				} else {
					return data.enviadoRO;
				}
			default:
				break;
		}
	};

	return (
		<>
			<ModalRechazoArchivo
				setOpen={setOpenModal}
				open={openModal}
				data={{
					id_archivo: dataModal.id,
					archivo: dataModal.title,
					resolucion: dataModal.resolucion,
					id_organo: dataModal.organo,
				}}
			/>

			<table className="table table-head-custom table-vertical-center border border-top">
				<thead>
					<tr>
						{itemsReTe.length === 0 ? (
							<></>
						) : (
							itemsReTe[0].dataMinos.map((i) => (
								<th tabIndex="0" className="text-center">
									{i.title}
								</th>
							))
						)}
					</tr>
				</thead>
				<tbody>
					<tr>
						{itemsReTe.length === 0 ? (
							<></>
						) : (
							<>
								{inpustfileC.map((item, index) => (
									<td className="text-center">
										<FileColumn
											rowIndex={0}
											onClickAcept={_onArchivoAceptar}
											onClickrechazar={_onArchivoClick}
											row={itemsReTe[0]}
											currentIcon={index}
											nameSesion={itemsReTe[0].nameSesion}
											btnFlag={onGetStatus(itemsReTe[0])}
											setFlagRender={setFlagRender}
										/>
									</td>
								))}
								<td className="text-center">
									{systemLevelRole !== 'CONSULTA' ? (
										<Button
											disabled={
												itemsReTe[0].dataMinos[0]
													.isSendDisabled ||
												onGetStatus(itemsReTe[0])
											}
											onClick={() => _onClickEnviar()}
											className="btn btn-primary"
										>
											Enviar
										</Button>
									) : (
										<></>
									)}
								</td>
							</>
						)}
					</tr>
				</tbody>
			</table>
		</>
	);
};

export default TablaDocumentos;
